export default "__VITE_PUBLIC_ASSET__d50ef2ec__"